module.exports = __webpack_public_path__ + "static/media/excursions.f4bab067.jpg";